class BlogNavigation extends HTMLElement { // eslint-disable-line
  constructor() {
    super()

    this.initialSlide = [...this.querySelectorAll('.swiper-slide')]?.findIndex(slide => slide.classList.contains('active')) || 0
    this.options = {
      slidesPerView: 'auto',
      threshold: 10,
      draggable: true,
      freeMode: true,
      mousewheel: true,
      slidesPerGroup: 1,
      initialSlide: this.initialSlide,
      mousewheel: {
        forceToAxis: true
      }
    }

    this.init()
  }

  init() {
    this.swiper = new Swiper(this, this.options)
  }
}

customElements.define('blog-navigation', BlogNavigation);
